import { MapPin } from "lucide-react";

const areas = [
  "Saint John",
  "Rothesay",
  "Quispamsis",
  "Hampton",
  "Grand Bay-Westfield",
  "St. Martins",
  "Sussex",
  "Fundy Trail",
  "Kennebecasis Valley",
  "West Side",
  "East Side",
  "Uptown",
];

export default function ServiceArea() {
  return (
    <section
      id="area"
      data-testid="area-section"
      className="px-6 md:px-12 lg:px-20 py-24 md:py-32 border-b border-[#2A2A2A]"
    >
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#FFD600]">
            04 — Where We Roll
          </span>
          <h2 className="font-display font-bold uppercase tracking-tight leading-[0.9] text-4xl sm:text-5xl lg:text-6xl mt-4">
            Greater
            <br />
            Saint John
            <br />
            <span className="text-[#00E5FF]">& beyond.</span>
          </h2>
          <p className="mt-6 text-gray-400 leading-relaxed max-w-md">
            Based in Saint John, NB. We service the Kennebecasis Valley, Fundy coastline, and out
            to Sussex on request. Outside the zone? Ask anyway — we travel for fleets.
          </p>

          <a
            href="#quote"
            data-testid="area-quote-btn"
            className="mt-8 inline-flex items-center gap-3 bg-[#FFD600] text-black font-bold uppercase tracking-wider px-7 py-4 hover:-translate-y-1 hover:shadow-[4px_4px_0_0_rgba(255,255,255,0.25)] transition-all"
          >
            Check Your Address
          </a>
        </div>

        <div className="lg:col-span-7">
          <div className="border border-[#2A2A2A] bg-[#0A0A0A] p-8 md:p-10">
            <div className="flex items-center gap-3 text-[#00E5FF]">
              <MapPin size={20} />
              <span className="text-xs font-bold uppercase tracking-[0.3em]">
                Coverage Map
              </span>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-[#2A2A2A] border border-[#2A2A2A] mt-6">
              {areas.map((a, i) => (
                <div
                  key={i}
                  className="bg-[#0A0A0A] hover:bg-[#FFD600] hover:text-black transition-colors p-5 group"
                >
                  <div className="font-display font-semibold uppercase tracking-tight text-lg">
                    {a}
                  </div>
                  <div className="text-[10px] uppercase tracking-widest text-gray-500 group-hover:text-black/70 mt-1">
                    NB · CA
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 pt-8 border-t border-[#2A2A2A] flex flex-wrap gap-6 text-sm text-gray-400">
              <span>
                <strong className="text-white">Travel fee?</strong> Free within 30 km of uptown.
              </span>
              <span>
                <strong className="text-white">Same-day quotes</strong> — text us a photo.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
